import React, { Suspense } from "react";
import "./Sass/App.scss";
import "./index.css";
import { BrowserRouter } from "react-router-dom";

// Importing JS libraries
// import 'jquery';
import "popper.js";
import "bootstrap";
import "perfect-scrollbar";
import "highlight.js/lib/core";
import AuthenticatedRoutes from "./Routes/AuthenticatedRoutes";
import NotAuthinticatedRoutes from "./Routes/NotAuthinticatedRoutes";
import Loader from "./Components/Loader";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { USER_TYPES } from "./constants/globals";

function App() {
  const { loggedInUser } = useSelector((state) => state?.Auth);

  const getTitle = () => {
    if (loggedInUser?.data?.model?.user_type_id === USER_TYPES.ADMIN)
      return "UNITERS ACADEMY ADMIN";
    if (loggedInUser?.data?.model?.user_type_id === USER_TYPES.MODERATOR)
      return "UNITERS ACADEMY MODERATOR";
    if (loggedInUser?.data?.model?.user_type_id === USER_TYPES.PARTNER)
      return "UNITERS ACADEMY PARTNER";

    return "UNITERS ACADEMY";
  };

  return (
    <>
      <Helmet>
        <title>{getTitle()}</title>
      </Helmet>
      <Suspense fallback={<Loader />}>
        <BrowserRouter>
          {Object.keys(loggedInUser).length > 0 ? (
            <>
              <AuthenticatedRoutes />
            </>
          ) : (
            <NotAuthinticatedRoutes />
          )}
        </BrowserRouter>
      </Suspense>
    </>
  );
}

export default App;
